<template>
    <div class="detail_page">
        <div class="detail_page_items">

            <div 
            class="preloader preloader_detail"
            v-if="detailPreloader"
            >
                <span class="preloader__item preloader__item1"></span>
                <span class="preloader__item preloader__item2"></span>
                <span class="preloader__item preloader__item3"></span>
                <span class="preloader__item preloader__item4"></span>
            </div>

            <button class="detail_page_close" @click="closeDetail()">X</button>
            <div class="detail_left_form_container">
                <div class="error_message"
                 v-if="mainFormError">
                    <span>Сервис временно недоступен =(</span>
                </div>
                <h3 class="detail_header"> FID #{{ fid }} </h3>
                <form 
                 class="detail_update_form"
                 @submit.prevent="changeFormSubmit()" 
                >
                    <label class="update_label" for="update_name">Название:</label>
                    <input
                    id="update_name"
                    v-model="form_name"
                    class="update_input">

                    <label class="update_label" for="update_regon">Регион:</label>
                    <select
                    id="update_region"
                    class="update_select"
                    v-if="incoming_properties"
                    v-model="form_region"
                    >
                        <option
                         v-for="(value, key) in this.all_regions"
                         :key="key"
                         :value="key"
                         :selected="incoming_properties.region == key">
                        {{ value }}
                        </option>
                    </select>

                    <label class="update_label" for="update_district">Район:</label>
                    <input
                    id="update_district"
                    v-model="form_district"
                    class="update_input">

                    <label class="update_label" for="update_type">Тип:</label>
                    <select 
                    id="update_type"
                    class="update_select"
                    v-if="incoming_properties"
                    v-model="form_type"
                    >
                        <option
                         :value="'курган'"
                         >
                         курган
                        </option>
                        <option
                         :value="'курганная группа'"
                         >
                         курганная группа
                        </option>
                        <option
                         :value="'могильник'"
                         >
                         могильник
                        </option>
                        <option
                         :value="'городище'"
                         >
                         городище
                        </option>
                        <option
                         :value="'селище'"
                         >
                         селище
                        </option>
                        <option
                         :value="'стоянка'"
                         >
                         стоянка
                        </option>
                        <option
                         :value="'местонахождение'"
                         >
                         местонахождение
                        </option>
                        <option
                         :value="'выработки'"
                         >
                         выработки
                        </option>
                        <option
                         :value="'пещера'"
                         >
                         пещера
                        </option>
                        <option
                         :value="'раскопан'"
                         >
                         раскопан
                        </option>
                    </select>

                    <label class="update_label" for="update_order">Документ о постановке:</label>
                    <input
                    id="update_order"
                    v-model="form_order"
                    class="update_input">

                    <label class="update_label" for="update_status">Статус:</label>
                    <select 
                    id="update_status"
                    class="update_select"
                    v-if="incoming_properties"
                    v-model="form_status"
                    >
                        <option
                         :value="'federal'"
                         >
                         федеральный
                        </option>
                        <option
                         :value="'regional'"
                         >
                         региональный
                        </option>
                        <option
                         :value="'non-existent'"
                         >
                         неучтенный
                        </option>
                        <option
                         :value="null"
                         >
                         нет данных
                        </option>
                    </select>

                    <label class="update_label" for="update_precision">Точность местоположения:</label>
                    <select 
                    id="update_precision"
                    class="update_select"
                    v-if="incoming_properties"
                    v-model="form_precision"
                    >
                        <option
                         :value="'1'"
                         >
                         точно
                        </option>
                        <option
                         :value="'0'"
                         >
                         не точно
                        </option>
                        <option
                         :value="null"
                         >
                         нет данных
                        </option>
                    </select>

                    <label class="update_label" for="update_description">Краткое описание:</label>
                    <textarea
                     class="update_textarea"
                     v-model="form_description"
                     id="update_description"
                    >
                    </textarea>
                    <button 
                     type="submit"
                     class="update_form_button"
                     v-if="form_button && STATE != 4"
                    >
                        Внести изменения
                    </button>
                </form>
            </div>
            <div class="detail_center_form_container">
                <div class="error_message"
                 v-if="textFormError">
                    <span>Сервис временно недоступен =(</span>
                </div>
                <h3 class="detail_header"> Текстовое описание: </h3>
                
                <textarea
                class="description_textarea"
                v-model="detail_text"
                id="update_description"
                >
                </textarea>
                <button
                @click="updateMemText" 
                class="update_form_button"
                v-if="detail_text_button && STATE != 4"
                >
                    Внести изменения
                </button>
            </div>
            <div class="detail_right_form_container">
                <div class="error_message"
                 v-if="fileFormError">
                    <span>Сервис временно недоступен =(</span>
                </div>
                <h3 class="detail_header"> Файлы и изображения: </h3>
                <div class="files_container">
                    <ul 
                     class="files_list_container"
                     >
                        <li 
                         class="files_list_item"
                         v-for="file in files_list"
                         :key="file.id"
                         >
                            <span class="files_item__name">{{ file.filename }}</span>
                            <div class="files_item__buttons">
                                <a 
                                 class="files_item__buttons_download_button" 
                                 :href='"http://localhost:5000/map/download_file/" + file.filename'>
                                    <svg
                                       width="5.2100725mm"
                                       height="5.1902251mm"
                                       viewBox="0 0 5.2100725 5.1902251">
                                      <g
                                         id="layer1"
                                         transform="translate(-105.73777,-70.332543)">
                                        <path
                                           style="fill:#f28116;fill-opacity:1;stroke:#000000;stroke-width:0.39396;stroke-linecap:round;stroke-dasharray:none"
                                           d="m 107.39328,70.540972 1.92867,-0.01035 -0.0893,2.49387 1.25797,0.06122 -2.18286,2.157551 -2.11539,-2.169314 1.23328,-0.03532 z"
                                           id="path1" />
                                      </g>
                                    </svg>
                                </a>
                                <button 
                                class="files_item__buttons_delete_button"
                                v-if="STATE != 4"
                                @click="deleteFile(file.id)"
                                >
                                    <svg
                                       width="4.0572677mm"
                                       height="4.6879029mm"
                                       viewBox="0 0 4.0572677 4.6879029">
                                      <g
                                         id="layer1"
                                         transform="translate(-113.34695,-70.25817)">
                                        <path
                                           style="fill:#ce0707;fill-opacity:1;stroke:#000000;stroke-width:0.273496;stroke-linecap:round;stroke-dasharray:none"
                                           d="m 113.53459,71.057012 0.6424,-0.599647 1.18015,1.431257 1.18019,-1.432683 0.67559,0.532701 -1.22382,1.574846 1.21894,1.530303 -0.64895,0.648582 -1.18729,-1.441137 -1.04605,1.452914 -0.74856,-0.54969 1.25007,-1.590745 z"
                                           id="path3" />
                                      </g>
                                    </svg>
                                </button>
                            </div>
                        </li>
                    </ul>
                    <div class="files_search_container">
                        <h4 class="detail_under"> Прикрепить: </h4>
                        <input
                         v-model="file_search_string"
                         class="file_search_input" 
                         type="text" 
                         name="fileSearch"
                         placeholder="Название файла..."
                         >
                         <ul 
                          class="all_files_list"
                          v-if="all_files">
                             <li
                              class="all_files_list_item"
                              v-for="file in all_files"
                              :key="file"
                             >
                             <span class="files_item__name">{{ file }}</span>
                             <input 
                              type="checkbox" 
                              @change="addFileCheck($event, file)"
                              >
                             </li>
                         </ul>
                         <button
                          class="add_existing_file_button"
                          v-if="files_to_add.length && STATE != 4"
                          @click="addFilesToMem"
                          >
                             Прикрепить
                         </button>
                    </div>
                </div>
                <form class="mem_upload_file_button"
                 v-if="STATE !=4"
                 >
                    <label class="mem_upload_file">
                        
                            Загрузить файл
                        
                        <input type="file"
                         ref="uploadFile" 
                         class="mem_file_input"
                         @change="onUploadFile"
                         >
                    </label>
                </form>
                <map-detail-slider
                 :images="images"
                 :token="TOKEN"
                 v-if="isImages()">
                    
                </map-detail-slider>
                <span
                 class="no_images_container"
                 v-if="!isImages()">
                    Изображений нет =(    
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import {getMemInfo, updatePoint, getMemText, updateText, getMemFiles, sendMemFile, deleteMemFile, 
        searchMemFiles, addFilesMem} from '@/api/mapItems'
import mapDetailSlider from '././mapDetailSlider.vue';
export default {
    name: 'mapDetail',
     components: {
        mapDetailSlider,
    },
    props: {
      msg: String,
      fid: Number,
      token: String,
      state: Number
    },
    watch: {
        FID(){
            this.getData(this.TOKEN, this.FID)
            
        },
        form_region(){
            this.checkIfChanges()
        },
        form_type(){
            this.checkIfChanges()
        },
        form_name(){
            this.checkIfChanges()
        },
        form_district(){
            this.checkIfChanges()
        },
        form_order(){
            this.checkIfChanges()
        },
        form_status(){
            this.checkIfChanges()
        },
        form_precision(){
            this.checkIfChanges()
        },
        form_description(){
            this.checkIfChanges()
        },
        detail_text(){
            this.checkTextChanges()
        },
        mem_file(){
            console.log(this.mem_file)
        },
        file_search_string(){
            this.searchMemFiles(this.file_search_string)
        },
        
    },
    data(){
        return {
            detailPreloader: true,

            FID: null,
            TOKEN: null,
            STATE: null,
            incoming_properties: null,
            all_regions: JSON.parse(localStorage.getItem('all_regions')),

            form_button: false,
            detail_text_button: false,

            form_name: null,
            form_region: null,
            form_district: null,
            form_type: null,
            form_order: null,
            form_status: null,
            form_precision: null,
            form_description: null,

            detail_text: null,

            files_list: null,
            mem_file: null,

            all_files: null,
            files_to_add: [],
            file_search_string: '',

            images: {},

            mainFormError: false,
            textFormError: false,
            fileFormError: false,
        };
    },
    methods: {
        closeDetail(){
            this.$emit('toggle-detail')
        },
        async getData(token, fid){
            this.detailPreloader = true
            let data = await getMemInfo(token, fid)
            let text = await getMemText(token, fid)
            let files = await getMemFiles(token, fid)
            if(data){
                data = data.features[0].properties
                this.incoming_properties = data
                this.incoming_properties.files_list = files.data
                this.form_name = this.incoming_properties.name
                this.form_district = this.incoming_properties.district
                this.form_region = this.incoming_properties.region
                this.form_type = this.incoming_properties.type
                this.form_order = this.incoming_properties.av_order
                this.form_status = this.incoming_properties.status
                this.form_precision = this.incoming_properties.pos
                this.form_description = this.incoming_properties.notes
                this.files_list = this.incoming_properties.files_list
                if(text){
                    this.incoming_properties.text = text.text
                    this.detail_text = text.text
                }else{
                    this.detail_text = null
                }
                
                await this.updateImages()
            }else{
                this.$emit('toggle-detail')
            }
            this.detailPreloader = false
        },
        async checkIfChanges(){
            let check = false;
            if(!check && this.form_region.toString() != this.incoming_properties.region.toString()){
                check = true
            }
            if(!check && this.form_type != this.incoming_properties.type){
                check = true
            }
            if(!check && this.form_name != this.incoming_properties.name){
                check = true
            }
            if(!check && this.form_district != this.incoming_properties.district){
                check = true
            }
            if(!check && this.form_district != this.incoming_properties.district){
                check = true
            }
            if(!check && this.form_order != this.incoming_properties.av_order){
                check = true
            }
            if(!check && this.form_status != this.incoming_properties.status){
                check = true
            }
            if(!check && this.form_status != this.incoming_properties.status){
                check = true
            }
            if(!check && this.form_precision != this.incoming_properties.pos){
                check = true
            }
            if(!check && this.form_description != this.incoming_properties.notes){
                check = true
            }

            if(check){
                this.form_button = true;
            }else{
                this.form_button = false;
            }
        },
        async checkTextChanges(){
            if(this.incoming_properties.text != this.detail_text){
                this.detail_text_button = true
            }else{
                this.detail_text_button = false
            }
        },
        async changeFormSubmit(){
            this.detailPreloader = true
            let result = await updatePoint(this.token,
                                        {
                                            "fid": this.FID,
                                            "name": this.form_name,
                                            "region": this.form_region,
                                            "district": this.form_district,
                                            "type": this.form_type,
                                            "av_order": this.form_order,
                                            "status": this.form_status,
                                            "pos": this.form_precision,
                                            "notes": this.form_description
                                        })
            if(result){
                await this.getData(this.TOKEN, this.FID)
                this.form_button = false;
            }else{
                this.mainFormError = true;
                this.$emit('toggle-detail')
            }
        },
        async updateMemText(){
            this.detailPreloader = true
            let result = await updateText(this.TOKEN, {
                "fid": this.FID,
                "text": this.detail_text
            })
            if(!result){
                this.textFormError = true;
            }
            this.detail_text_button = false
            this.detailPreloader = false
        },
        async sendFile(){
            console.log(this.mem_file)
        },
        async onUploadFile(event){
            this.detailPreloader = true
            const file = event.target.files[0]
            const uploaded = await sendMemFile(this.TOKEN, {"file": file,
                                           "fid": this.FID})
            if(uploaded){
                let newFiles = await getMemFiles(this.TOKEN, this.FID)
                this.files_list = newFiles.data
                await this.updateImages()
            }else{
                this.fileFormError = true
            }
            this.detailPreloader = false
        },
        async deleteFile(fileId){
            this.detailPreloader = true
            const deleted = await deleteMemFile(this.TOKEN, fileId)
            if(deleted){
                let newFiles = await getMemFiles(this.TOKEN, this.FID)
                this.files_list = newFiles.data
                await this.updateImages()
            }else{
                this.fileFormError = true
            }
            this.detailPreloader = false
        },
        async searchMemFiles(search_string){
            if(search_string.length >= 3){
                let result = await searchMemFiles(this.TOKEN, search_string)
                if(result){
                    this.all_files = result.data
                }else{
                    this.all_files = null
                    this.files_to_add = []
                }
            }else{
                this.all_files = null
                this.files_to_add = []
            }
        },
        async addFileCheck(event, value){
            if(event.target.checked){
                this.files_to_add.push(value)
            }else{
                this.files_to_add = this.files_to_add.filter(function(item) {
                                        return item !== value
                                    })
            }
        },
        async addFilesToMem(){
            this.detailPreloader = true
            let addFiles = await addFilesMem(this.TOKEN, this.files_to_add, this.FID)
            if(addFiles){
                await new Promise(r => setTimeout(r, 2000));
                let newFiles = await getMemFiles(this.TOKEN, this.FID)
                this.files_list = newFiles.data
                this.files_to_add = []
                this.all_files = []
                await this.updateImages()
            }else{
                this.fileFormError = true
                this.files_to_add = []
                this.all_files = []
                await this.updateImages()
            }
            this.detailPreloader = false
            
        },
        async updateImages(){
            this.images = {}
            let num = 1
            if(this.files_list){
                this.files_list.forEach(file =>{
                    if(file.filename.endsWith('.png') || file.filename.endsWith('.jpg') || file.filename.endsWith('.jpeg')){
                        this.images[num] = file.filename
                        num += 1
                    }
                })
            }
        },
        isImages(){
            return Object.keys(this.images).length > 0
        }
    },
    computed: {
        currentFid(){
            return this.fid
        }
    },
    async created(){
        this.FID = this.fid
        this.TOKEN = this.token
        this.STATE = this.state
        console.log(this.STATE)
    }
}
</script>